import { render, staticRenderFns } from "./addOrEditParent.vue?vue&type=template&id=4f1cae8e&scoped=true&"
import script from "./addOrEditParent.vue?vue&type=script&lang=js&"
export * from "./addOrEditParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1cae8e",
  null
  
)

export default component.exports